import { useNavigate } from 'react-router-dom'
import { useLanguage } from '@/hooks/useLanguage'
import { t } from '@/utils/i18n'
import EmptyState from '@/components/common/EmptyState/EmptyState'
import Button from '@/components/common/Button/Button'
import { IconSearch } from '@/components/icons/Icons'
import './NotFound.css'

function NotFound() {
  const navigate = useNavigate()
  const { language } = useLanguage()

  return (
    <div className="not-found">
      <div className="not-found__content">
        <EmptyState
          icon={<IconSearch size={32} />}
          title={t('error.notFound', language) || '페이지를 찾을 수 없습니다'}
          description={t('error.notFoundDesc', language) || '요청하신 페이지가 존재하지 않거나 이동되었습니다.'}
        />
        <div className="not-found__actions">
          <Button
            variant="primary"
            onClick={() => navigate('/dreams')}
          >
            {t('error.goHome', language) || '홈으로 이동'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NotFound

